import { createContext, useContext, useEffect, useMemo, useRef, MouseEvent } from 'react';
import { ModuleData } from '../../Types/containerV2';
import { importScope, scopeImportedCss, scopeImportedMarkup } from '../../Utils/importedHtml';
import './ImportedCodeModules.scss';
import { useContainerContext } from './ContainerContext';
import { installImportedAnchorNavigation } from '../../Utils/importedAnchors';

export const ImportedGroupContext = createContext<{ scope: string; source: string } | null>(null);

export function HtmlCodeModule({ module }: { module: ModuleData }) {
	const root = useRef<HTMLDivElement>(null);
	const { isClickActionEnabled } = useContainerContext();
	const navigationEnabled = isClickActionEnabled('link');
	const group = useContext(ImportedGroupContext);
	const scope = group?.scope ?? importScope(module.guid);
	const html = useMemo(
		() => scopeImportedMarkup(String(module.content.htmlCode ?? ''), scope, group?.source),
		[module.content.htmlCode, scope, group?.source]
	);
	useEffect(() => {
		if (navigationEnabled && root.current) return installImportedAnchorNavigation(root.current);
	}, [html, navigationEnabled]);
	const preventAdminNavigation = (event: MouseEvent<HTMLDivElement>) => {
		if (!navigationEnabled && (event.target as Element).closest('a')) event.preventDefault();
	};
	return (
		<div
			ref={root}
			className={`biz-html-code${group ? '' : ` ${scope}`}`}
			onClickCapture={preventAdminNavigation}
			onAuxClickCapture={preventAdminNavigation}
			dangerouslySetInnerHTML={{ __html: html }}
		/>
	);
}

export function SharedCssModule() {
	// The nearest Segment collects these before rendering its children, independent of their order.
	return null;
}

export function getImportedGroupCss(modules: ModuleData[], scope: string): string {
	const source = modules
		.filter((m) => m.moduleType === 'SharedCss')
		.map((m) => String(m.content.sharedCss ?? ''))
		.join('\n');
	return scopeImportedCss(source, scope).css;
}
